import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, Typography, Backdrop, Slide, Box, Portal } from "@mui/material";
import MDButton from "components/MDButton";
import Plan from "layouts/profile/components/Subscription/plan";

import Pack from "layouts/profile/components/Addons/pack";
import WorkspaceService from "services/workspace-service";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";

function UsageUpgrade({
    open,
    onClose,
    featureName = "Monthly Search",
    planRequired = "Higher Plan",
    currentPlan,
    usageLimit,
    unit = "profiles", // [NEW] Default unit
    message = null // [NEW] Custom message override
}) {
    const [showPlan, setShowPlan] = useState(false);
    const [showPack, setShowPack] = useState(false);
    const [entitlements, setEntitlements] = useState(null);

    React.useEffect(() => {
        if (!open) {
            setShowPlan(false);
            setShowPack(false);
        } else {
            WorkspaceService.fetchWorkspaceEntitlements().then(res => setEntitlements(res)).catch(console.error);
        }
    }, [open]);

    return (
        <Portal>
            <Backdrop
                open={open && !showPlan && !showPack}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 30,
                    backgroundColor: "rgba(0,0,0,0.5)",
                    backdropFilter: "blur(4px)",
                }}
                onClick={onClose}
            >
                <Slide direction="up" in={open && !showPlan && !showPack} mountOnEnter unmountOnExit>
                    <Card
                        onClick={(e) => e.stopPropagation()}
                        sx={{
                            p: 4,
                            maxWidth: 460,
                            width: "90%",
                            borderRadius: "16px",
                            textAlign: "center",
                            backgroundColor: "rgba(255,255,255,0.95)",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
                        }}
                    >
                        <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                            You are on the {currentPlan || "Basic"} plan
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            {message ? (
                                <span dangerouslySetInnerHTML={{ __html: message }} />
                            ) : (
                                <>You have used all <strong>{usageLimit}</strong> {unit} available in this plan.</>
                            )}
                        </Typography>

                        <MDButton
                            variant="contained"
                            color="accent"
                            size="medium"
                            onClick={() => setShowPlan(true)}
                            sx={{ px: 3, py: 1.2, fontWeight: 600, width: "auto", minWidth: "180px", alignSelf: "center" }}
                        >
                            UPGRADE PLAN
                        </MDButton>

                        {/* Separate link to open add-ons store */}
                        <MDButton
                            variant="text"
                            color="info"
                            size="small"
                            startIcon={<ShoppingBagIcon />}
                            onClick={() => setShowPack(true)}
                            sx={{ mt: 2, display: 'flex', mx: 'auto', textTransform: 'none', fontWeight: 'bold' }}
                        >
                            Or Buy Add-ons
                        </MDButton>

                        <MDButton
                            variant="text"
                            color="secondary"
                            size="small"
                            onClick={onClose}
                            sx={{ mt: 1, display: 'block', mx: 'auto' }}
                        >
                            Cancel
                        </MDButton>
                    </Card>
                </Slide>
            </Backdrop>

            {/* PLAN UPGRADE */}
            <Backdrop
                open={showPlan}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 40,
                    backgroundColor: "rgba(0,0,0,0.8)",
                }}
            >
                <Slide direction="up" in={showPlan} mountOnEnter unmountOnExit>
                    <Card
                        sx={{
                            width: "95%",
                            maxWidth: "1100px",
                            maxHeight: "95vh",
                            overflowY: "auto",
                            p: 3,
                            backgroundColor: "white",
                            borderRadius: "16px",
                            position: "relative",
                        }}
                    >
                        <Box mt={3}>
                            <Plan onClose={() => { setShowPlan(false); onClose(); }} />
                        </Box>
                    </Card>
                </Slide>
            </Backdrop>

            {/* ADD-ON STORE */}
            <Backdrop
                open={showPack}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 40,
                    backgroundColor: "rgba(0,0,0,0.8)",
                }}
            >
                <Slide direction="up" in={showPack} mountOnEnter unmountOnExit>
                    <Card
                        sx={{
                            width: "95%",
                            maxWidth: "1100px",
                            maxHeight: "95vh",
                            overflowY: "auto",
                            p: 3,
                            backgroundColor: "white",
                            borderRadius: "16px",
                            position: "relative",
                        }}
                    >
                        <Box mt={3}>
                            <Pack onClose={() => { setShowPack(false); onClose(); }} entitlements={entitlements} />
                        </Box>
                    </Card>
                </Slide>
            </Backdrop>
        </Portal>
    );
}

UsageUpgrade.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    featureName: PropTypes.string,
    planRequired: PropTypes.string,
    currentPlan: PropTypes.string,
    usageLimit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    unit: PropTypes.string,
    message: PropTypes.string, // [NEW]
};

export default UsageUpgrade;
